export default __webpack_public_path__ + "static/audio-cardio-5-b-9a394a2886669716f3d45915e790d633.webp";